export default __webpack_public_path__ + "static/media/about.e745cf78.jpg";